import { AgmCoreModule } from "@agm/core";
import { AgmSnazzyInfoWindowModule } from "@agm/snazzy-info-window";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { ContenteditableValueAccessorModule } from '@tinkoff/angular-contenteditable-accessor';
import { QRCodeModule } from "angularx-qrcode";
import { QuillModule } from 'ngx-quill';
import { googleMapsConfig } from "../../environments/environment";
import { BasketOrderComponent } from "../pages/basket-order/basket-order.component";
import { PipesModule } from "../pipes/pipes.module";
import { AddressNotFoundLinkComponent } from "./address-not-found-link/address-not-found-link.component";
import { AddressComponent } from "./address/address.component";
import { AmountEditorComponent } from "./amount-editor/amount-editor.component";
import { AppstoreBadgesComponent } from './appstore-badges/appstore-badges.component';
import { BasketFooterComponent } from "./basket-footer/basket-footer.component";
import { BasketItemComponent } from "./basket-item/basket-item.component";
import { BasketSummaryComponent } from "./basket-summary/basket-summary.component";
import { BasketComponent } from "./basket/basket.component";
import { CachedImageComponent } from "./cached-image/cached-image.component";
import { CardFormComponent } from "./card-form/card-form.component";
import { CashInComponent } from "./cash-in/cash-in.component";
import { ChipPanelComponent } from "./chip-panel/chip-panel.component";
import { ContactDetailsComponent } from "./contact-details/contact-details.component";
import { CountryPickerComponent } from "./country-picker/country-picker.component";
import { DatePlaceMultiSelectorComponent } from "./date-place-multi-selector/date-place-multi-selector.component";
import { DatePlaceSelectorComponent } from "./date-place-selector/date-place-selector.component";
import { DateSelectorModalComponent } from "./date-selector-modal/date-selector-modal.component";
import { DateSelectorComponent } from "./date-selector/date-selector.component";
import { DatesPlacesChipPanelComponent } from "./dates-places-chip-panel/dates-places-chip-panel.component";
import { DayCalendarComponent } from "./daycalendar/daycalendar.component";
import { DeliveryInfoComponent } from "./delivery-info/delivery-info.component";
import { FilterPanelComponent } from "./filter-panel/filter-panel.component";
import { FooterComponent } from "./footer/footer.component";
import { InfoHeaderComponent } from "./info-header/info-header.component";
import { InfoPopupComponent } from "./info-popup/info-popup.component";
import { LabelBadgeComponent } from "./label-badge/label-badge.component";
import { LegalLinkComponent } from './legal-link/legal-link.component';
import { LegalComponent } from "./legal/legal.component";
import { MapComponent } from "./map/map.component";
import { MessageComposerComponent } from "./message/message-composer.component";
import { NotificationUpdaterComponent } from "./notification-updater/notification-updater.component";
import { NotifiedListComponent } from "./notified-list/notified-list.component";
import { OptionSelectorComponent } from "./option-selector/option-selector.component";
import { OrderComponent } from './order/order.component';
import { PaymentsListComponent } from "./payments-list/payments-list.component";
import { PaymentsComponent } from "./payments/payments.component";
import { PhotoUploaderComponent } from "./photo-uploader/photo-uploader.component";
import { PlaceSelectorComponent } from "./place-selector/place-selector.component";
import { PlusMinusComponent } from "./plusminus/plusminus.component";
import { ProducerOrderComponent } from "./producer-order/producer-order.component";
import { ProducerViewComponent } from "./producer-view/producer-view.component";
import { ProductOrderedComponent } from "./product-ordered/product-ordered.component";
import { ProductStatsComponent } from "./product-stats/product-stats.component";
import { ProductViewComponent } from "./product-view/product-view.component";
import { ProductsListOrganizedComponent } from "./products-list-organized/products-list-organized.component";
import { ProductsListRowComponent } from "./products-list-row/products-list-row.component";
import { ProductsListComponent } from "./products-list/products-list.component";
import { ProfileBadgeComponent } from "./profile-badge/profile-badge.component";
import { ProfileCardComponent } from "./profile-card/profile-card.component";
import { ProfilesListComponent } from "./profiles-list/profiles-list.component";
import { QuantityEditorComponent } from "./quantity-editor/quantity-editor.component";
import { RecurrenceEditComponent } from "./recurrence-edit/recurrence-edit.component";
import { ReordererComponent } from "./reorderer/reorderer.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { RichTextComponent } from "./rich-text/rich-text.component";
import { SaleCardComponent } from "./sale-card/sale-card.component";
import { SaleHeaderComponent } from "./sale-header/sale-header.component";
import { SaleHistoryComponent } from "./sale-history/sale-history.component";
import { SalesListComponent } from "./sales-list/sales-list.component";
import { ShareComponent } from "./share/share.component";
import { StatusBadgeComponent } from "./status-badge/status-badge.component";
import { StatusHistoryComponent } from './status-history/status-history.component';
import { StockEditComponent } from "./stock-edit/stock-edit.component";
import { TimeSelectorComponent } from "./time-selector/time-selector.component";
import { ToggleIconComponent } from './toggle-icon/toggle-icon.component';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: googleMapsConfig.apiKey
    }),
    AgmSnazzyInfoWindowModule,
    PipesModule,
    ContenteditableValueAccessorModule,
    TranslateModule.forChild(),
    QRCodeModule,
    QuillModule,
  ],
  declarations: [
    DayCalendarComponent,
    PlusMinusComponent,
    LegalComponent,
    InfoHeaderComponent,
    MapComponent,
    SalesListComponent,
    ProductsListComponent,
    BasketComponent,
    ProfilesListComponent,
    ProductsListOrganizedComponent,
    PhotoUploaderComponent,
    BasketFooterComponent,
    BasketSummaryComponent,
    BasketItemComponent,
    BasketOrderComponent,
    StatusBadgeComponent,
    ProducerViewComponent,
    ProductViewComponent,
    LabelBadgeComponent,
    CardFormComponent,
    OrderComponent,
    StatusHistoryComponent,
    AppstoreBadgesComponent,
    LegalLinkComponent,
    ToggleIconComponent,
    NotificationUpdaterComponent,
    RecurrenceEditComponent,
    ReordererComponent,
    OptionSelectorComponent,
    CountryPickerComponent,
    ProductOrderedComponent,
    DeliveryInfoComponent,
    ContactDetailsComponent,
    AddressComponent,
    FooterComponent,
    ProducerViewComponent,
    CachedImageComponent,
    ProfileCardComponent,
    FilterPanelComponent,
    ProductsListRowComponent,
    ResetPasswordComponent,
    DateSelectorComponent,
    TimeSelectorComponent,
    AmountEditorComponent,
    QuantityEditorComponent,
    CashInComponent,
    PaymentsListComponent,
    ProductStatsComponent,
    PlaceSelectorComponent,
    ChipPanelComponent,
    MessageComposerComponent,
    NotifiedListComponent,
    DatePlaceSelectorComponent,
    DatePlaceMultiSelectorComponent,
    DatesPlacesChipPanelComponent,
    PaymentsComponent,
    SaleHeaderComponent,
    SaleHistoryComponent,
    AddressNotFoundLinkComponent,
    ProducerOrderComponent,
    ProfileBadgeComponent,
    DateSelectorModalComponent,
    SaleCardComponent,
    ShareComponent,
    StockEditComponent,
    InfoPopupComponent,
    RichTextComponent,
  ],
  exports: [
    DayCalendarComponent,
    PlusMinusComponent,
    LegalComponent,
    InfoHeaderComponent,
    MapComponent,
    SalesListComponent,
    ProductsListComponent,
    BasketComponent,
    ProfilesListComponent,
    ProductsListOrganizedComponent,
    PhotoUploaderComponent,
    BasketFooterComponent,
    BasketSummaryComponent,
    BasketItemComponent,
    BasketOrderComponent,
    StatusBadgeComponent,
    LabelBadgeComponent,
    CardFormComponent,
    OrderComponent,
    StatusHistoryComponent,
    AppstoreBadgesComponent,
    LegalLinkComponent,
    ToggleIconComponent,
    NotificationUpdaterComponent,
    RecurrenceEditComponent,
    ReordererComponent,
    OptionSelectorComponent,
    CountryPickerComponent,
    ProductOrderedComponent,
    DeliveryInfoComponent,
    ContactDetailsComponent,
    AddressComponent,
    FooterComponent,
    ProducerViewComponent,
    CachedImageComponent,
    ProfileCardComponent,
    FilterPanelComponent,
    ProductsListRowComponent,
    ResetPasswordComponent,
    DateSelectorComponent,
    TimeSelectorComponent,
    AmountEditorComponent,
    QuantityEditorComponent,
    CashInComponent,
    PaymentsListComponent,
    ProductStatsComponent,
    PlaceSelectorComponent,
    ChipPanelComponent,
    MessageComposerComponent,
    NotifiedListComponent,
    DatePlaceSelectorComponent,
    DatePlaceMultiSelectorComponent,
    DatesPlacesChipPanelComponent,
    PaymentsComponent,
    SaleHeaderComponent,
    SaleHistoryComponent,
    AddressNotFoundLinkComponent,
    ProducerOrderComponent,
    ProfileBadgeComponent,
    DateSelectorModalComponent,
    SaleCardComponent,
    ShareComponent,
    StockEditComponent,
    InfoPopupComponent,
    RichTextComponent,
  ]
})
export class ComponentsModule {}
